import { routes as login } from './login'

import { routes as conversation } from './conversation'

import { routes as contact } from './contact'

export default [
  {
    path: '/',
    redirect: { name: 'login' }
  },
  ...login,
  ...conversation,
  ...contact
]
